module.exports = __webpack_public_path__ + "static/media/arrowLeftFirstItemGrey.d66320e1.svg";